<template>
<div class="update-leaps-challenge-overlay">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" v-on:click="updateHideUpdateLeapsChallengeOverlayFlag($event,true)">
                    <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                  <span>Title</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px">
                      <input type="text" class="form-control" v-model="objToPass.ChallengeTitle" :maxlength="maxLength">
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2"></div>
                <div class="col-md-2 col-lg-2 text-align-left create-lesson-input-text-style">
                  <div class="form-group">
                    <div class="checkbox">
                      <label><input type="checkbox" v-model="objToPass.IsActive">Is Active</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2"></div>  
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="create-lesson-input-text-style padding-left-0Px col-md-1 col-lg-1 text-align-right">
                  <span>Category</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-4 col-lg-4 text-align-left">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px" id="vueMultiSelect">
                      <vue-multi-select
                        search
                        :filters="categoryFilters"
                        btnClass="cssClass"
                        v-model="selectedCategoryValues"
                        :btnLabel="btnCategoryLabel"
                        :options="categoryOptions"
                        :selectOptions="categoryData" />
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1 padding-right-0Px create-lesson-input-text-style text-align-right">
                  Intention
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px" id="vueMultiSelectForIntention">
                      <vue-multi-select
                        search
                        :filters="intentionFilters"
                        btnClass="cssClass"
                        v-model="selectedIntentionValues"
                        :btnLabel="btnIntentionLabel"
                        :options="intentionOptions"
                        :selectOptions="intentionData" />
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <span>Description</span>
                </div>
                <div class="col-md-9 col-lg-9 padding-left-0Px">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <tinymce id="d1" v-model="objToPass.ChallengeDescription"></tinymce>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>

              <div class="row">
                <div class="create-lesson-input-text-style col-md-2 margin-Top-Bottom-1Point5Perc col-lg-2 text-align-right">
                  Associate Actions
                </div>
                <div class="col-md-9 col-lg-9 padding-left-0Px">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <challenge-action-association :serverChallengeActions="objToPass.ChallengeActions" :isComingFromCreate="false" @updateValues="upateActionAssociationValue" v-if="!serverProcessGoingOn"></challenge-action-association>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>

              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateLeapsChallenge">Update</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
 </div>
 </div>
</template>

<script>
import findIndex from 'lodash/findIndex'
import tinymce from 'vue-tinymce-editor'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { leapsChallengesService } from '@/server-util/leaps-challenges-service'
import Loader from '@/components/dashboard/Loader'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import ChallengeActionAssociation from './ChallengeActionAssociation.vue'
import { leapsCategoryService } from '@/server-util/leaps-category-service'
import vueMultiSelect from 'vue-multi-select'
import 'vue-multi-select/dist/lib/vue-multi-select.css'
import { forEach, find } from 'lodash'
import { leapsIntentionService } from '@/server-util/leaps-intention-service'
export default {
  props: ['currSelectedObj'],
  created: function () {
    this.getLeapsCategoryList()
  },
  data: function () {
    return {
      constants: constants,
      maxLength: constants.Leaps_Title_Max_Length,
      showAlertDialog: false,
      errorMsg: '',
      objToPass: {
        ChallengeLibraryId: '',
        ChallengeTitle: '',
        ChallengeDescription: '',
        IsActive: false,
        CreatedTS: '',
        UpdatedTS: '',
        ChallengeActions: [],
        ChallengeCategories: [],
        ChallengeIntentions: []
      },
      showSpinner: false,
      serverProcessGoingOn: false,
      hasUpdatedLeapsChallengeSuccessfully: false,
      createdObj: null,
      btnCategoryLabel: selectedCategoryValues => selectedCategoryValues.length > 0 ? selectedCategoryValues.length === 1 ? '1 Category is selected' : selectedCategoryValues.length + ' Categories are selected' : 'Select Single/Multiple Categories',
      selectedCategoryValues: [],
      categoryData: [],
      categoryOptions: {
        multi: true,
        groups: false,
        cssSelected: option => (option.selected ? { 'color': '#f39c12', 'font-weight': '500', 'opacity': '1' } : { 'opacity': '0.8' })
      },
      categoryFilters: [{
        nameAll: 'Select all',
        nameNotAll: 'Deselect all',
        func () {
          return true
        }
      }],
      btnIntentionLabel: selectedIntentionValues => selectedIntentionValues.length > 0 ? selectedIntentionValues.length === 1 ? '1 Intention is selected' : selectedIntentionValues.length + ' Intentions are selected' : 'Select Single/Multiple Intentions',
      selectedIntentionValues: [],
      intentionData: [],
      intentionOptions: {
        multi: true,
        groups: false,
        cssSelected: option => (option.selected ? { 'color': '#f39c12', 'font-weight': '500', 'opacity': '1' } : { 'opacity': '0.8' })
      },
      intentionFilters: [{
        nameAll: 'Select all',
        nameNotAll: 'Deselect all',
        func () {
          return true
        }
      }]
    }
  },
  name: 'update-leaps-challenge-overlay',
  methods: {
    getLeapsCategoryList: function () {
      this.serverProcessGoingOn = true
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        this.$store.state.isLoading = true
        leapsCategoryService
          .getLeapsCategoryList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsCategoryList = responseObj.data
              this.getLeapsIntentionList()
            } else {
              this.$store.state.isLoading = false
              this.serverProcessGoingOn = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.serverProcessGoingOn = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        this.serverProcessGoingOn = false
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS CATEGORY LIST'
        )
      }
    },
    getLeapsIntentionList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        leapsIntentionService
          .getLeapsIntentionList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsIntentionList = responseObj.data
              this.setDefaultValues()
              this.$store.state.isLoading = false
              this.serverProcessGoingOn = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.serverProcessGoingOn = false
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.serverProcessGoingOn = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        this.serverProcessGoingOn = false
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS INTENTION LIST'
        )
      }
    },
    upateActionAssociationValue (value) {
      switch (value.operationName) {
        case 'update-associated-actions-array':
          this.objToPass.ChallengeActions = value.challengeActions
          break
      }
    },
    bindChallengeCategories: function (challengeCategories) {
      var arrToReturn = []
      forEach(challengeCategories, (categoryId) => {
        const foundObj = find(this.getGlobalCategoryList, (obj) => {
          return categoryId === obj.CategoryId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          var objToPush = {
            name: foundObj.CategoryTitle,
            categoryid: foundObj.CategoryId
          }
          arrToReturn.push(objToPush)
        }
      })
      return arrToReturn
    },
    bindChallengeIntentions: function (challengeIntentions) {
      var arrToReturn = []
      forEach(challengeIntentions, (intentionId) => {
        const foundObj = find(this.getGlobalIntentionList, (obj) => {
          return intentionId === obj.IntentionLibraryId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          var objToPush = {
            name: foundObj.IntentionTitle,
            intentionid: foundObj.IntentionLibraryId
          }
          arrToReturn.push(objToPush)
        }
      })
      return arrToReturn
    },
    setDefaultValues: function () {
      if (this.currSelectedObj.ChallengeActions !== undefined && this.currSelectedObj.ChallengeActions !== 'undefined' && this.currSelectedObj.ChallengeActions !== null && this.currSelectedObj.ChallengeActions !== 'null' && this.currSelectedObj.ChallengeActions !== '') {
        this.objToPass.ChallengeActions = JSON.parse(this.currSelectedObj.ChallengeActions)
      }
      this.objToPass.ChallengeLibraryId = this.currSelectedObj.ChallengeLibraryId
      this.objToPass.ChallengeTitle = this.currSelectedObj.ChallengeTitle
      if (this.currSelectedObj.ChallengeDescription !== undefined && this.currSelectedObj.ChallengeDescription !== 'undefined' && this.currSelectedObj.ChallengeDescription !== null && this.currSelectedObj.ChallengeDescription !== 'null' && this.currSelectedObj.ChallengeDescription !== '' && this.currSelectedObj.ChallengeDescription.trim().length !== 0 && this.stripHtml(this.currSelectedObj.ChallengeDescription).trim().length !== 0) {
        setTimeout(() => {
          this.objToPass.ChallengeDescription = dmAdminUtils.updateUrls(this.currSelectedObj.ChallengeDescription)
        }, 500)
      } else {
        this.objToPass.ChallengeDescription = ''
      }
      this.objToPass.IsActive = this.currSelectedObj.IsActive
      this.objToPass.CreatedTS = this.currSelectedObj.CreatedTS
      this.objToPass.UpdatedTS = this.currSelectedObj.UpdatedTS
      this.selectedCategoryValues = (this.currSelectedObj.ChallengeCategories !== undefined && this.currSelectedObj.ChallengeCategories !== 'undefined' && this.currSelectedObj.ChallengeCategories !== null && this.currSelectedObj.ChallengeCategories !== 'null' && this.currSelectedObj.ChallengeCategories !== '') ? this.bindChallengeCategories(JSON.parse(this.currSelectedObj.ChallengeCategories)) : []
      this.objToPass.ChallengeCategories = this.selectedCategoryValues
      forEach(this.getGlobalCategoryList, (obj) => {
        var objToPush = {
          name: obj.CategoryTitle,
          categoryid: obj.CategoryId
        }
        this.categoryData.push(objToPush)
      })
      this.selectedIntentionValues = (this.currSelectedObj.ChallengeIntentions !== undefined && this.currSelectedObj.ChallengeIntentions !== 'undefined' && this.currSelectedObj.ChallengeIntentions !== null && this.currSelectedObj.ChallengeIntentions !== 'null' && this.currSelectedObj.ChallengeIntentions !== '') ? this.bindChallengeIntentions(JSON.parse(this.currSelectedObj.ChallengeIntentions)) : []
      this.objToPass.ChallengeIntentions = this.selectedIntentionValues
      forEach(this.getGlobalIntentionList, (obj) => {
        var objToPush = {
          name: obj.IntentionTitle,
          intentionid: obj.IntentionLibraryId
        }
        this.intentionData.push(objToPush)
      })
    },
    updateHideUpdateLeapsChallengeOverlayFlag: function (event, flagToUpdate) {
      var objToReturn = {
        closeOverlay: true,
        createdObj: null
      }
      this.$emit('emittedValue', objToReturn)
    },
    checkAndUpdateMasterLeapChallengeList: function () {
      const foundIndex = findIndex(this.$store.state.leapsChallengesList, (obj) => {
        return obj.ChallengeLibraryId === this.objToPass.ChallengeLibraryId
      })
      if (foundIndex > -1) {
        this.$store.state.leapsChallengesList[foundIndex] = this.createdObj
      }
    },
    updateLeapsChallenge: function () {
      var storeObj = this.$store
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (
          storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
        ) {
          this.objToPass.ChallengeDescription = (this.objToPass.ChallengeDescription !== undefined && this.objToPass.ChallengeDescription !== 'undefined' && this.objToPass.ChallengeDescription !== null && this.objToPass.ChallengeDescription !== 'null' && this.objToPass.ChallengeDescription !== '' && this.objToPass.ChallengeDescription.trim().length !== 0 && this.stripHtml(this.objToPass.ChallengeDescription).trim().length !== 0) ? dmAdminUtils.removeTFromUrls(this.objToPass.ChallengeDescription) : null
          this.objToPass.ChallengeActions = JSON.stringify(this.objToPass.ChallengeActions)
          var categoryObjToPush = []
          forEach(this.selectedCategoryValues, (obj) => {
            categoryObjToPush.push(obj.categoryid)
          })
          this.objToPass.ChallengeCategories = JSON.stringify(categoryObjToPush)
          if (this.selectedIntentionValues !== undefined && this.selectedIntentionValues !== 'undefined' && this.selectedIntentionValues !== null && this.selectedIntentionValues !== 'null' && this.selectedIntentionValues !== '' && this.selectedIntentionValues.length !== 0) {
            var intentionObjToPush = []
            forEach(this.selectedIntentionValues, (obj) => {
              intentionObjToPush.push(obj.intentionid)
            })
            this.objToPass.ChallengeIntentions = JSON.stringify(intentionObjToPush)
          } else {
            this.objToPass.ChallengeIntentions = null
          }
          this.$store.state.isLoading = true
          leapsChallengesService
            .updateLeapsChallenge(
              storeObj.state.access_token,
              this.objToPass
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.hasUpdatedLeapsChallengeSuccessfully = true
                this.createdObj = responseObj.data
                this.checkAndUpdateMasterLeapChallengeList()
                this.showAlertDialog = true
                this.errorMsg = '\'' + this.objToPass.ChallengeTitle + '\' goal updated successfully.'
                this.$store.state.isLoading = false
              } else {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                this.objToPass.ChallengeActions = JSON.parse(this.objToPass.ChallengeActions)
                this.objToPass.ChallengeCategories = JSON.parse(this.objToPass.ChallengeCategories)
                this.objToPass.ChallengeIntentions = JSON.parse(this.objToPass.ChallengeIntentions)
              }
            }, errorObj => {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
              this.objToPass.ChallengeActions = JSON.parse(this.objToPass.ChallengeActions)
              this.objToPass.ChallengeCategories = JSON.parse(this.objToPass.ChallengeCategories)
              this.objToPass.ChallengeIntentions = JSON.parse(this.objToPass.ChallengeIntentions)
            })
        } else {
          console.log(
            'Access Token is NULL hence declined CREATE NEW LEAPS GOAL.'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.hasUpdatedLeapsChallengeSuccessfully) {
        // AK: Hide Update LEAPS Goal Overlay
        var objToReturn = {
          closeOverlay: true,
          createdObj: this.createdObj
        }
        this.$emit('emittedValue', objToReturn)
        this.hasUpdatedLeapsChallengeSuccessfully = false
        this.createdObj = null
      }
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.objToPass.ChallengeTitle.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if (this.objToPass.ChallengeCategoryId === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select category.'
        return false
      } else if (this.objToPass.ChallengeActions.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please associate atleast one action with \'' + this.objToPass.ChallengeTitle + '\'.'
        return false
      }
      return true
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'tinymce': tinymce,
    'challenge-action-association': ChallengeActionAssociation,
    'vue-multi-select': vueMultiSelect
  },
  computed: {
    getGlobalCategoryList: {
      get: function () {
        return this.$store.state.leapsCategoryList
      },
      set: function (newValue) {
        this.$store.state.leapsCategoryList = newValue
      }
    },
    getGlobalIntentionList: {
      get: function () {
        return this.$store.state.leapsIntentionList
      },
      set: function (newValue) {
        this.$store.state.leapsIntentionList = newValue
      }
    }
  }
}
</script>

<style scoped>
.text-color-red {
  color: red;
}
.margin-Top-Bottom-1Point5Perc {
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 7%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
</style>
<style>
#vueMultiSelect .select {
  width: 100%;
  min-width: 100%;
}

#vueMultiSelect button.btn-select {
  min-width: 100%;
}
#vueMultiSelect .select .checkboxLayer {
  width: 100%;
}
#vueMultiSelect .select .helperButton {
  width: 100px !important;
  color: #000;
}
#vueMultiSelect .select .helperButton:hover {
  background-color: #ffffff;
  color: #000;
}
#vueMultiSelect ul>li .margin-left-20 {
  background-color: #fff;
  word-wrap: break-word;
  display: inline-block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: normal;
  line-break: strict;
  hyphens: none;
  -webkit-hyphens: none;
  -moz-hyphens: none;
}
#vueMultiSelectForIntention .select {
  width: 100%;
  min-width: 100%;
}

#vueMultiSelectForIntention button.btn-select {
  min-width: 100%;
}
#vueMultiSelectForIntention .select .checkboxLayer {
  width: 100%;
}
#vueMultiSelectForIntention .select .helperButton {
  width: 100px !important;
  color: #000;
}
#vueMultiSelectForIntention .select .helperButton:hover {
  background-color: #ffffff;
  color: #000;
}
#vueMultiSelectForIntention ul>li .margin-left-20 {
  background-color: #fff;
  word-wrap: break-word;
  display: inline-block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: normal;
  line-break: strict;
  hyphens: none;
  -webkit-hyphens: none;
  -moz-hyphens: none;
}
</style>




// WEBPACK FOOTER //
// src/components/leaps/challenges/UpdateLeapsChallengeOverlay.vue